import { api, ApiError } from './client'
import type { ApiVehicle } from './types'
import type { ImageUploadResult } from './agents'

export interface VinFromImageResponse {
  vin: string
}

interface AgentsVinResponse {
  img: ImageUploadResult
  vin: string | null
}

export const vinApi = {
  /** Search vehicle by VIN (actual backend endpoint) */
  searchByVin: (vin: string) => api.get<ApiVehicle>(`/vehicles/search/vin/${vin}`),

  /** Decode a 17-char VIN from a still photo via the BE agent
   *  (POST /agents/images/vin, tracker #72). BE uploads to
   *  Cloudflare Images then runs the VIN-recognition agent on the
   *  resulting URL; returns `{ img, vin }` where `vin` may be null
   *  if no VIN was found. We collapse the null case to a thrown
   *  ApiError so callers can use one try/catch path for "couldn't
   *  read it" and fall back to manual typing. */
  fromImage: async (file: File): Promise<VinFromImageResponse> => {
    const formData = new FormData()
    formData.append('image', file)
    const result = await api.post<AgentsVinResponse>(
      '/agents/images/vin',
      formData,
    )
    if (!result.vin) {
      throw new ApiError(422, "Couldn't find a VIN in the image")
    }
    return { vin: result.vin }
  },
}
